import React from "react";
import {Grid,Row,Col} from 'react-flexbox-grid';
import { CXContext } from "./cxContext";
import * as dc from "dc";
import * as d3 from 'd3';
import { rhythm } from "../utils/typography.js";
import { css } from "glamor";

let metric = "# of Entries";

const commasFormatter = (num) => {
  return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)//d3.format(",.0f");
}

const Options = props => {
  const options = ["# of Entries", "Total # of Words", "Average # of Words", "Total Vocabulary","Average Vocabulary", "# of Asignments"];//"Total # of Activities", "Average # of Activities"

  const updateChart = (metric) => {
    if(props.chart) {
      const val = props.chart.valueAccessor(function(p) {
        //console.log('metric '+metric);
        if( metric == "# of Entries") return p.value.count;
        else if( metric == "Total # of Words") return p.value.totalWords;
        else if(metric == "Average # of Words") return p.value.avgWords;
        // else if(metric == "Total Vocabulary") return p.value.totalVocabulary;
        // else if(metric == "Average Vocabulary") return p.value.avgVocabulary;
        else if(metric == "# of Asignments") return p.value.id_count;
        else if(metric == "# of Students") return p.value.student_count;
        // else if(metric == 'Total Conversation Time') return p.value.tot_conversation_time;
        // else if(metric == 'Average Conversation Time') return p.value.avg_conversation_time;
      });
      if(props.chartType == 'rowchart'){
        props.chart.xAxis().tickFormat(function(d) { return commasFormatter(d) ; }).ticks(5)

      }
      props.chart.title(function(p) {
        if( metric == "# of Entries") return d3.format(",d")(p.value.count);
        else if( metric == "Total # of Words") return d3.format(",d")(p.value.totalWords);
        else if(metric == "Average # of Words") return d3.format(",.2f")(p.value.avgWords);
        // else if(metric == "Total Vocabulary") return d3.format(",d")(p.value.totalVocabulary);
        // else if(metric == "Average Vocabulary") return d3.format(",.2f")(p.value.avgVocabulary);
        else if(metric == "# of Asignments") return d3.format(",d")(p.value.id_count);
        else if(metric == "# of Students") return d3.format(",d")(p.value.student_count);
      })
      props.chart.colors(function() {
        if( metric == "# of Entries") return [ '#065FE5'];
        else if( metric == "Total # of Words") return ['#2B4E7B'];
        else if(metric == "Average # of Words") return['#2B4E7B'];
        // else if(metric == "Total Vocabulary") return ['#BB3232'];
        // else if(metric == "Average Vocabulary") return ['#BB3232'];
        else if(metric == "# of Asignments") return ['#97D318'];
        else if(metric == "# of Students") return ['#FFA826'];
      })

      props.chart.redraw();
    }
  }

  const resetChart = (reset) => {
    if(reset) {
      if(props.chart ) {
        props.chart.filterAll();
        dc.redrawAll();
      }
    }
  }

  updateChart(props.metric);
  //if(props.reset)
  resetChart(props.reset)

  return (
  ""
  )
}


export const SmallMultiplesTemplate = props => {
    /*
    We render the dc chart using an effect. We want to pass the chart as a prop after the dc call,
    but there is nothing by default to trigger a re-render and the prop, by default would be undefined.
    To solve this, we hold a state key and increment it after the effect ran.
    By passing the key to the parent div, we get a rerender once the chart is defined.
    */
  const context = React.useContext(CXContext);
  const [chart,updateChart] = React.useState(null);
  const ndx = context.ndx;
  const calc = metric//context.calc;
  const index = React.useRef(null);
  const div = React.useRef(null);
  const n = 1;

  React.useEffect(() => {
    const key = props.index;
    const newChart = props.chartFunction(div.current, ndx, key); // chartfunction takes the ref and does something with it

    newChart.render();
    updateChart(newChart);
  },[1]); {/*Run this exactly once */}

  const chartStyles  = css({
    maxWidth:'100%',
    height:'auto',
    boxSizing:'border-box',
    //marginRight: rhythm(2),
    paddingTop: rhythm(0),
    paddingRight: rhythm(.01),
    paddingBottom: rhythm(.01),
    paddingLeft: rhythm(.01),
    '& label':{
      textTransform:'capitalize',
    }

  })
  return (
    <div
      ref={div}
      {...chartStyles}
    >
      <Options chart={chart} reset={props.reset} chartType={props.type} metric={props.metric} studentGradesMetric={props.studentGradesMetric}/>
    </div>
  );
};
